import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
      role="navigation"
      aria-label="主导航"
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className={`font-heading text-xl md:text-2xl font-black tracking-tight ${
              scrolled || !isHome ? 'text-primary-500' : 'text-white'
            }`}>
              51<span className="text-accent-500">黑料</span>网
            </span>
          </Link>

          {/* Desktop Nav Links */}
          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/80 hover:text-white'
              } ${location.pathname === '/' ? (scrolled || !isHome ? 'text-primary-500' : 'text-white') : ''}`}
            >
              首页
            </Link>
            <Link
              to="/category/yiqu"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/80 hover:text-white'
              } ${location.pathname.includes('/category/') ? (scrolled || !isHome ? 'text-primary-500' : 'text-white') : ''}`}
            >
              一区
            </Link>
            <Link
              to="/category/erqu"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/80 hover:text-white'
              }`}
            >
              二区
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/80 hover:text-white'
              } ${location.pathname === '/about' ? (scrolled || !isHome ? 'text-primary-500' : 'text-white') : ''}`}
            >
              关于我们
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-lg transition-colors ${
              scrolled || !isHome
                ? 'text-foreground-800 hover:bg-background-200'
                : 'text-white hover:bg-white/10'
            }`}
            aria-label="切换菜单"
            aria-expanded={mobileOpen}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-4 px-2">
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg cursor-pointer whitespace-nowrap transition-colors"
              >
                首页
              </Link>
              <Link
                to="/category/yiqu"
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg cursor-pointer whitespace-nowrap transition-colors"
              >
                一区 · 明星娱乐圈
              </Link>
              <Link
                to="/category/erqu"
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg cursor-pointer whitespace-nowrap transition-colors"
              >
                二区 · 网红达人圈
              </Link>
              <Link
                to="/about"
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg cursor-pointer whitespace-nowrap transition-colors"
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}